import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import { useLocation } from 'react-router-dom';
import { Event } from '../../api/events';
import { getRoutePath, Pages } from '../../router/constants';
import PopupIcon from '../common/popup-icon';

interface HomeworkIconProps {
  session: Event;
}

function HomeworkIcon({ session }: HomeworkIconProps) {
  const location = useLocation();

  return (
    <PopupIcon
      to={{
        pathname: getRoutePath(Pages.SESSIONS_DETAILS, {
          sessionId: session.id,
        }),
        search: 'anchor=homework',
        state: {
          prevPath: `${location.pathname}${location.search}`,
        },
      }}
      icon={<AssignmentTurnedInIcon />}
      testId='session-homework-icon'
      content={session.homework}
      emptyText='No data available.'
      isNoIcon={!session.homework}
    />
  );
}

export default HomeworkIcon;
